//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"MATLABCoSimType",1,0],[0,"MATLABServerProgID",1,0],[0,"MatlabFileBrowser",1,0],[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0],[1,"UpdateTime",0,"Expression",0]],[[["serverName","numTags"],"GetServerTags",{R_:{tagInfos:""}},1,0],[["numTags","signalName","signalType"],"GetAvailableItems",{},0,0],[["signalName","signalType"],"SetAvailableItems",{},2,0],[["numTags","attr"],"GetItemAttributes",{},0,0],[["attr"],"SetItemAttributes",{},1,0],[["instanceName","numTags","tagInfos"],"GetMATLABInformation",{},1,0],[["instanceName","tagInfos"],"SetMATLABInformation",{},2,0],[["instanceName","numTags","tagInfos"],"GetMATLABInformationEx",{},1,1],[["instanceName","tagInfos"],"SetMATLABInformationEx",{},2,1],[["ownerPart"],"GetMATLABServerName",{R_:{maltabServerProgID:''}},1,0],[["ownerPart","matlabServerProgID"],"SetMATLABServerName",{},2,0],[["instanceName","ownerPart","numTags","tagInfos"],"GetMATLABInformationExV2",{},2,0],[["instanceName","ownerPart","tagInfos"],"SetMATLABInformationExV2",{},3,0]],[]];
SPLM.Mechatronics.MATLABClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.MATLABClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.MATLABClientBuilder.TagInfo = class{
    constructor(name,eIOType,eDataType){
        this.name=name;this.eIOType=eIOType;this.eDataType=eDataType;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
};

SPLM.Mechatronics.MATLABClientBuilder.TagInfoEx = class{
    constructor(name,eIOType,dataType){
        this.name=name;this.eIOType=eIOType;this.dataType=dataType;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Datatype(){return this.dataType}
    set Datatype(val){this.dataType = val}
};

SPLM.Mechatronics.MATLABClientBuilder.TagAttribute = class{
    constructor(signalName,signalType,signalportType){
        this.signalName=signalName;this.signalType=signalType;this.signalportType=signalportType;}
    get Signalname(){return this.signalName}
    set Signalname(val){this.signalName = val}
    get Signaltype(){return this.signalType}
    set Signaltype(val){this.signalType = val}
    get Signalporttype(){return this.signalportType}
    set Signalporttype(val){this.signalportType = val}
};

SPLM.Mechatronics.MATLABClientBuilder.SignalData = class{
    constructor(name,dataType,portType){
        this.name=name;this.dataType=dataType;this.portType=portType;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Datatype(){return this.dataType}
    set Datatype(val){this.dataType = val}
    get Porttype(){return this.portType}
    set Porttype(val){this.portType = val}
};

SPLM.Mechatronics.MATLABClientBuilder.DataType = Object.freeze({
    "Bool" : "Bool", "Int" : "Int", "Double" : "Double"});

SPLM.Mechatronics.MATLABClientBuilder.DataPortType = Object.freeze({
    "Input" : "Input", "Output" : "Output"});

SPLM.Mechatronics.MATLABClientBuilder.CoSimType = Object.freeze({
    "C" : "C", "S" : "S"});

export default SPLM;